<template>
  <form v-if="resort" class="form" v-on:submit.prevent="updateResort">
    <h1>Resort: {{ resort.resort_name }}</h1>
    <div class="box">
      <Errors/>
      <ResortFields/>
      <div class="form-wrap form-submit">
        <div class="mt-1" v-if="this.getLoadStatus">
          <button type="submit" class="button" disabled><span>Updating...</span></button>
        </div>
        <div class="mt-1" v-else>
          <button type="submit" class="button" v-if="userRole ==1"><span>Update resort</span></button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import ResortFields from '@/components/ResortFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'ResortEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data () {
    return {
      resort: null,
      errors: null
    }
  },
  components: {
    ResortFields,
    Errors
  },
  created () {
    this.getResort()
  },
  watch: {
    '$route': 'getResort'
  },
  methods: {
    getResort () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'resorts/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.resort = response.data[0]
      })
    },
    updateResort () {
      console.log(this.resort)
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'resorts/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.resort),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        console.log(response)
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
